import React from 'react'
import { Box, Button, Card, CardContent, Chip, Grid, Typography } from '@mui/material'
import WorkOutlineIcon from '@mui/icons-material/WorkOutline'
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline'
import TrendingUpIcon from '@mui/icons-material/TrendingUp'
import Logo from 'static/images/logo.svg'

const STEPS = [
  {
    icon: WorkOutlineIcon,
    title: 'Post Your Job',
    description: 'Enter your position details and it goes live instantly.',
  },
  {
    icon: PeopleOutlineIcon,
    title: 'Preview Your Matches',
    description: 'See how many qualified candidates already match your role.',
  },
  {
    icon: TrendingUpIcon,
    title: 'Get the Full Picture',
    description: 'Schedule a demo to unlock your complete candidate list.',
  },
]

const KioskWelcomeStep = ({ onNext }) => {
  return (
    <Box sx={{ textAlign: 'center', py: 4 }}>
      <Box sx={{ mb: 3 }}>
        <img src={Logo} alt='MyStethi' style={{ height: 48 }} />
      </Box>
      <Chip
        label='AAPPR 2026 Exclusive'
        color='primary'
        size='small'
        sx={{ mb: 2, fontWeight: 'bold' }}
      />
      <Typography variant='h3' fontWeight='bold' gutterBottom>
        One Free Job Posting
      </Typography>
      <Typography variant='h6' color='text.secondary' sx={{ mb: 1 }}>
        Post a job, see a sneak peek of your candidate matches
      </Typography>
      <Typography variant='body1' color='text.secondary' sx={{ mb: 5, maxWidth: 520, mx: 'auto' }}>
        MyStethi uses AI-powered matching to connect your open positions with qualified, high-intent
        candidates who are actively looking.
      </Typography>

      <Grid container spacing={3} sx={{ mb: 5, maxWidth: 720, mx: 'auto' }}>
        {STEPS.map((step, index) => (
          <Grid item xs={12} sm={4} key={step.title}>
            <Card
              variant='outlined'
              sx={{
                height: '100%',
                borderColor: 'divider',
                borderRadius: 2,
                textAlign: 'center',
              }}
            >
              <CardContent sx={{ py: 3 }}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: '50%',
                    backgroundColor: 'primary.main',
                    color: '#fff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mx: 'auto',
                    mb: 2,
                  }}
                >
                  <step.icon />
                </Box>
                <Typography variant='subtitle1' fontWeight='bold' gutterBottom>
                  {index + 1}. {step.title}
                </Typography>
                <Typography variant='body2' color='text.secondary'>
                  {step.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Button variant='contained' size='large' onClick={onNext} sx={{ px: 5, py: 1.5 }}>
        Post My Free Job
      </Button>
    </Box>
  )
}

export default KioskWelcomeStep
